import React, { Component } from 'react';
import Helping from '../../helpers/Helping';
import {
    MESSAGE
} from '../../config/index';
import { API_URL } from '../../config/urls';
import { connect } from "react-redux";
import Notification from '../layout/Notification';
import { setErrorFields, validateField } from '../../helpers/validationHelpers';
import { LOOKUPS } from '../../config/routes';
import LoadingButton from '../fields/LoadingButton';
import Select from '../fields/dropDownWithSelect';
import { GET_LOOKUP } from '../../config/routes';
import Service from '../../helpers/service';
import $ from 'jquery';

const { CREATE, DELETE, EMPTY } = MESSAGE;
class Relation extends Component {
    selectRef = [];
    constructor(props) {
        super(props);

        this.state = {
            url: API_URL.ADMIN_TRADING_API + GET_LOOKUP,
            type: 'add',
            lookup_id: '',
            child_id: '',
            parent_id: '',
            error_message: '',
            error_type: '',
            isLoading: true,
            btnIsDisable: false
        };
    }

    componentDidMount() {
        var that = this;
        this.getAllLookups();

        $(".close-slide").click(function () {
            that.resetForm();
            that.removeNetworkError();
            that.props.closeModal();
        });
    }

    handleInputChange = async (e) => {
        if (e) {
            let target = e;

            if (e.target) {
                target = e.target
            }
            const { name, value } = target;
            this.setState({ [name]: value });
            if (name === "parent_id") this.setState({ ...await validateField("string", name, value) });
            if (name === "lookup_id") this.setState({ ...await validateField("string", name, value) });
            if (name === "child_id") this.setState({ ...await validateField("string", name, value) });
            if (name === "type") this.setState({ ...await validateField("string", name, value, "", 1) });
        }
    }

    scrollToTop = () => {
        $('.addButton-slide').animate({ scrollTop: 0 }, 'slow');
    }

    getAllLookups = () => {
        let body = {
            action: "list",
            page: 1,
            sorting: "id",
            sort_type: "DESC",
            all: true
        }
        Service.postCall(API_URL.ADMIN_TRADING_API + LOOKUPS, body).then(res => {
            this.setState({ allLookups: res.data.payload.lookups })
        }).catch(error => {
            console.log({ error });
        })
    }

    resetForm = () => {
        this.setState({
            type: 'add',
            lookup_id: '',
            child_id: '',
            parent_id: '',
            isLoading: true,
            btnIsDisable: false,
            error_type_message: '',
            error_lookup_id_message: '',
            error_child_id_message: '',
            error_parent_id_message: ''
        }
            ,
            () => this.clearSelectFilter()
        )
    }

    refCallback = (name, val) => {
        const index = this.selectRef.findIndex((element) => Object.keys(element).toString() === name);

        if (index < 0) {
            const obj = {};
            obj[name] = val;
            this.selectRef.push(obj);
        }
        else {
            if (val)
                this.selectRef[index][name] = val;
        }
    }

    clearSelectFilter = () => {
        this.selectRef.map((ref, i) => {
            const key = Object.keys(ref).toString();

            ref[key].select.clearValue();
        })
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    };

    checkEmptyFields = () => {
        const { type, lookup_id, child_id } = this.state;
        let formHasError = false;

        if (!type) {
            let errorObject = setErrorFields("type", Helping.getMessageString(EMPTY, "type"));
            this.setState(errorObject);
            formHasError = true;
        }
        if (!lookup_id) {
            let errorObject = setErrorFields("lookup_id", Helping.getMessageString(EMPTY, "lookup_id"));
            this.setState(errorObject);
            formHasError = true;
        }
        if (!child_id) {
            let errorObject = setErrorFields("child_id", Helping.getMessageString(EMPTY, "child_id"));
            this.setState(errorObject);
            formHasError = true;
        }
        return formHasError;
    }

    submitLookupRelation = (e) => {
        e.preventDefault();

        const { type, lookup_id, child_id, parent_id } = this.state;
        let type_message = '',
            formHasError = this.checkEmptyFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        })

        if (type == "add")
            type_message = CREATE;
        else if (type == "remove")
            type_message = DELETE;

        let body = {
            action: "lookup-relation",
            type: type,
            lookup_id: Number(lookup_id),
            child_id: Number(child_id),
            parent_id: Number(parent_id)
        }

        Service.postCall(API_URL.ADMIN_TRADING_API + LOOKUPS, body).then(res => {
            this.props.getList();
            this.setState({
                error_message: Helping.getMessageString(type_message, 'lookup relation'),
                error_type: 'success',
                btnIsDisable: false
            },
                () => { this.scrollToTop(); this.resetForm() }
            );
        }).catch(error => {
            if (error.response) {
                Helping.redirectToLogin(error);
                return this.setState({
                    error_message: error.response.data.message.message,
                    error_type: 'danger',
                    btnIsDisable: false
                }, () => { this.scrollToTop(); })
            }
            return this.setState({
                isLoading: false,
                btnIsDisable: false,
                ...Helping.setNetworkRequestError(error, "adding/removing lookup relation")
            }, () => { this.scrollToTop(); })
        });
    }

    render() {
        return (
            <div class="addButton-slide right-slider add-category">
                <div class="slide-top">
                    <div class="slide-header">
                        <h4 class="title">New Relation</h4>
                        <span class="caption">Create Relations between parent and products.</span>
                    </div>
                </div>

                {this.state.error_message &&
                    <Notification
                        type={this.state.error_type}
                        message={this.state.error_message}
                        callback={this.removeNetworkError}
                    />
                }

                <form action="" class="info">
                    <div class="form-group">
                        <label for="relationType">Type</label> <br />
                        <select class={`form-select ${this.state.error_type_message ? 'error-input' : ''}`} name="type"
                            aria-label="select type" value={this.state.type} id="relationType" onChange={(e) => this.handleInputChange(e)}
                        >
                            <option value="add">Add</option>
                        </select>
                        <span className="error-msg">{this.state.error_type_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="lookupID">Lookup ID</label> <br />
                        <Select field="lookup_id" name="lookup_id" id="lookupID"
                            valuesArray={this.state.allLookups}
                            valueToBeSelected="id"
                            valueToBeSelectedKey={["name", "name"]} dependency="parent"
                            userSelectedFieldValue={this.state.lookup_id}
                            callback={this.refCallback}
                            selectChangeFunction={this.handleInputChange}
                        />
                        <span className="error-msg">{this.state.error_lookup_id_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="childID">Child ID</label> <br />
                        <Select field="child_id" name="child_id" id="childID"
                            valuesArray={this.state.allLookups}
                            valueToBeSelected="id"
                            valueToBeSelectedKey={["name", "name"]} dependency="parent"
                            userSelectedFieldValue={this.state.child_id}
                            callback={this.refCallback}
                            selectChangeFunction={this.handleInputChange}
                        />
                        <span className="error-msg">{this.state.error_child_id_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="parentID">Parent ID</label> <br />
                        <Select field="parent_id" name="parent_id" id="parentID"
                            valuesArray={this.state.allLookups}
                            valueToBeSelected="id"
                            valueToBeSelectedKey={["name", "name"]} dependency="parent"
                            userSelectedFieldValue={this.state.parent_id}
                            callback={this.refCallback}
                            selectChangeFunction={this.handleInputChange}
                        />
                        <span className="error-msg">{this.state.error_parent_id_message}</span>
                    </div>
                    <div class="slide-btn">
                        <div className="float-left">
                            <button class="close-slide custom-btn semi-dark-btn sm-btn" onClick={e => e.preventDefault()}>Close</button>
                        </div>

                        <div class="float-right">
                            <button class="custom-btn semi-dark-btn sm-btn" onClick={(e) => { e.preventDefault(); this.resetForm() }}>Reset</button>

                            {this.state.btnIsDisable ?
                                <LoadingButton class_name={"sm-btn"} />
                                :
                                <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.submitLookupRelation(e)}>{this.state.btnIsDisable ? "Loading..." : "Submit"}</button>
                            }
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    profile: state.profile,
});

export default connect(
    mapStateToProps,
    null
)(Relation);
